import {
    AudioLoader,
    AudioListener,
    Audio
} from 'three'

import { gsap } from 'gsap'
import { defPath } from '../config/defPath'


// ------------------------------------------------------------


export class SoundController {

    #_initialized = false
    #_muted = false

    #_loader = new AudioLoader()
    #_listener = undefined
    #_buffers = { }
    #_sounds = { }

    #_camera

    #_DOMelem = document.querySelector('.UI-sound')

    constructor(camera) {
        this.#_camera = camera
    }

    //

    load(fileNamesArray) {

        const path = `${defPath}/assets/sounds/`
        const loadControl = window.loadControl

        for( let i = 0; i < fileNamesArray.length; i++) {

            const fileName = fileNamesArray[i]
            this.#_buffers[fileName] = new Promise( resolve => {
                this.#_loader.load(`${path}${fileName}.mp3`,
                    (buffer) => {
                        resolve(buffer)
                    },
                    (xhr) => {
                        loadControl.elements['sound_' + fileName] = { loaded: xhr.loaded, total: xhr.total }
                        if (loadControl.allowLogSize && xhr.loaded === xhr.total) console.log(`Sound "${fileName}" - ${(xhr.total / 1024 / 1024).toFixed(2)}Mb`)
                    },
                    (error) => {
                        console.warn(`Error loading `)
                    }
                )
            })
        }

    }

    init() {
        if (this.#_initialized) return

        this.#_listener = new AudioListener()
        this.#_camera.add(this.#_listener)

        this.#_DOMelem.addEventListener('pointerup', () => {
            this.toggleMute()
        })

        if(sessionStorage.getItem('soundMuted') === 'true') this.toggleMute('true')

        this.#_initialized = true
    }

    async play(name, loop, volume, delay) {

        if(!this.#_sounds[name]) {
            // console.log('Sound not ready: ' + name)
            const sound = new Audio( this.#_listener )
            sound.setBuffer( await this.#_buffers[name] )
            sound.setLoop( loop )

            this.#_sounds[name] = sound
        }
        
        this.#_sounds[name].setVolume( volume )

        // if (this.#_muted === true) return
        
        if(this.#_sounds[name].isPlaying) this.#_sounds[name].stop()
        this.#_sounds[name].currentTime = 0
        
        // Delay in seconds
        if(delay) {
            this.#_sounds[name].play(delay)
        } else {
            this.#_sounds[name].play()
        }
    }

    async play2(name, url) {
        if (this.#_muted === true) return
        const sound = new Audio( new AudioListener() )
        const buffer = new Promise( resolve => {
            this.#_loader.load(`${window.origin}${url}`,
                (buffer) => {
                    resolve(buffer)
                },
                (xhr) => {
                    loadControl.elements['sound_' + name] = { loaded: xhr.loaded, total: xhr.total }
                    if (loadControl.allowLogSize && xhr.loaded === xhr.total) console.log(`Sound "${name}" - ${(xhr.total / 1024 / 1024).toFixed(2)}Mb`)
                },
                (error) => {
                    console.warn(`Error loading `)
                }
            )
        })
        sound.setBuffer( await buffer )
        sound.setLoop( false )

        this.#_sounds[name] = sound
        
        if(this.#_sounds[name].isPlaying) this.#_sounds[name].stop()
        this.#_sounds[name].currentTime = 0
        
        this.#_sounds[name].play(1)
    }

    stop(name, fadeOut) {

        const sound = this.#_sounds[name]
        const v = sound.getVolume()

        fadeOut = fadeOut ? fadeOut : 0.33
        
        gsap.to({v}, {
            v: 0,
            duration: fadeOut,
            ease: "power1.out",
            onUpdate() {
                const w = this.targets()[0].v
                sound.setVolume( w )
            },
            onComplete() {
                sound.stop()
            }
        })

    }

    toggleMute(value) {

        const listener = this.#_listener

        const g = (init, final) => {
            let t = gsap.to( {x: init}, {
                x: final,
                duration: 0.5,
                onUpdate() {
                    listener.setMasterVolume( this.targets()[0].x )
                },
                onComplete() {
                    t = null
                }
            })
        }

        if(!value) {
            if (this.#_muted) {
                g(0,1)
                this.#_muted = false 
                this.#_DOMelem.classList.remove('muted')
                sessionStorage.setItem('soundMuted', 'false')
            } else {
                g(1,0)
                this.#_muted = true
                this.#_DOMelem.classList.add('muted')
                sessionStorage.setItem('soundMuted', 'true')
            }
        } else {
            listener.setMasterVolume( 0 )
            this.#_muted = true
            this.#_DOMelem.classList.add('muted')
        }

    }
}